// Page
export const ROUTE_SERVICE_CHANGE = 'ROUTE_SERVICE_CHANGE'

// Rate My Service
export const RATE_MY_SERVICE_MODAL_CHANGE = 'RATE_MY_SERVICE_MODAL_CHANGE'
export const RATE_MY_SERVICE_QUESTIONS = 'RATE_MY_SERVICE_QUESTIONS'
export const RATE_MY_SERVICE_RATED = 'RATE_MY_SERVICE_RATED'
export const RATE_MY_SERVICE_REDIRECT_URL = 'RATE_MY_SERVICE_REDIRECT_URL'

//Rate My Service Segment
export const RATE_MY_SERVICE_MODAL_VIEWED = 'Service Rating Modal Viewed'
export const RATE_MY_SERVICE_SUCCESS_VIEWED = 'Service Rating Success Viewed'
export const RATE_MY_SERVICE_LOAD_FAILED = 'Service Rating Load Failed'
export const RATE_MY_SERVICE_SUBMITTED = 'Service Rating Submitted'
export const RATE_MY_SERVICE_SKIPPED = 'Service Rating Skipped'
export const RATE_MY_SERVICE_SUBMISSION_COMPLETED =
'Service Rating Submission Completed'
export const RATE_MY_SERVICE_SUBMISSION_FAILED =
  'Service Rating Submission Failed'
export const RATE_MY_SERVICE_SUCCESS_INTERACTED =
  'Service Rating Success Interacted'
